class ItemCount extends HTMLElement {
  static observedAttributes = ["count"];

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'count') return;

    const count = parseInt(this.getAttribute('count'), 10);

    if (!isFinite(count)) return;

    this.innerHTML = count === 1 ? "1 item selected" : `${count} items selected`;
  }
}

if (!customElements.get("item-count")) {
  customElements.define("item-count", ItemCount);
}
